import {
    ApiAuthAppSessionResSchema,
    ApiAttributionContextSchema,
    ApiNetworkContextBootstrapStateSchema,
    validators,
} from "@bridge-applications/pb-types";
import { z } from "zod";

export const AuthSliceSchema = z.object({
    sessionGeneration: z.number().int().nonnegative().default(0),
    bootstrapStatus: z.enum([
        "idle",
        "authenticating",
        "ready",
        "error",
        "no-telegram",
    ]),
    userId: z.uuid().nullable(),
    accountCreatedAt: ApiAuthAppSessionResSchema.shape.accountCreatedAt
        .unwrap()
        .nullable(),
    telegramUserId: validators.telegramId().nullable(),
    attributionContext: ApiAttributionContextSchema.nullable().default(null),
    networkContextState: ApiNetworkContextBootstrapStateSchema.nullable(),
    careerAccess: z
        .object({ userId: z.uuid(), allowed: z.boolean() })
        .nullable(),
    error: z.string().nullable(),
});

export type AuthSlice = z.infer<typeof AuthSliceSchema>;
